import { render, staticRenderFns } from "./SubLevelAdd.vue?vue&type=template&id=fbfd3206&scoped=true&"
import script from "./SubLevelAdd.vue?vue&type=script&lang=js&"
export * from "./SubLevelAdd.vue?vue&type=script&lang=js&"
import style0 from "./SubLevelAdd.vue?vue&type=style&index=0&id=fbfd3206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfd3206",
  null
  
)

export default component.exports